module.exports = __webpack_public_path__ + "img/1.f7f698f5.jpg";